import React, { useEffect, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import debounce from 'lodash/debounce';
import { LoadingStatusWrapper } from 'sharedComponents/WithLoadingStatus';
import { TrendChart } from '../../CommonCharts/Trend';
import {
    getUserLimitsForChart
} from './helpers';
import './style.scss';
import { apiCallStatus } from 'helpers/constants';
import { LoadingIndicator } from 'sharedComponents/PowertrainLoadingIndicator';


const TrendChartsComponent = (props) => {
    const { model, actions, multiChart } = props;
    const [trendLoadingStatus, setTrendLoadingStatus] = useState(apiCallStatus.LOADING);

    const {
        availableKPIs,
        multiChartPreselection,
        multiChartData,
        userLimits,
        userLimitsLoadingStatus,
        dateSelection,
        loadingStatusForCharts
    } = model;
    const {
        loadMultiChartData
    } = actions;

    const debouncedLoadData = useCallback(
        debounce((kpis, selection, date, isZoom = false) => {
            loadMultiChartData(kpis, selection, date, isZoom);
        }, 50),
        []
    );

    useEffect(() => {
        if (availableKPIs && dateSelection) {
            setTrendLoadingStatus(apiCallStatus.LOADING);
            debouncedLoadData(availableKPIs, multiChartPreselection, dateSelection);
        }
    }, [multiChartPreselection, dateSelection, availableKPIs]);

    useEffect(() => {
        const allSuccess = multiChartData.every((chart) => chart.loadingStatus === apiCallStatus.SUCCESS);
        if (allSuccess) {
            setTrendLoadingStatus(apiCallStatus.SUCCESS);
        }
    }, [multiChartData]);

    const reloadAllSelectedTrendKpiData = () => {
        loadMultiChartData(availableKPIs, multiChartPreselection, dateSelection);
    };

    const zoomInMultiCharts = (availableTrendKPIs, selectedTrendKPIs, from, to) => {
        loadMultiChartData(availableTrendKPIs, multiChartPreselection, { from, to }, true);
    };

    const renderChart = useCallback((chart) => {
        const { data, zoom, chartID, loadingStatus } = chart;

        return <div key={chartID} id={chartID} className={`multi-graph-item ${chartID}`}>
            <React.Suspense fallback={<LoadingIndicator />}>
                <TrendChart
                    selectedTrendKPIs={map(data, (item) => item.kpiIdentifier)}
                    selectedTrendsData={data}
                    trendDataLoadingStatus={loadingStatus}
                    userLimits={getUserLimitsForChart(
                        userLimits,
                        map(data, (item) => item.kpiIdentifier)
                    )}
                    enableUniqueScaling={false}
                    lastMeasurementTimeStampLabel={null}
                    isZoomed={zoom.isZoomed}
                    availableTrendKPIs={availableKPIs}
                    chartKey={`${chartID}`}
                    reloadAllSelectedTrendKpiData={reloadAllSelectedTrendKpiData}
                    zoomInToSelectedTrendKpiData={zoomInMultiCharts}
                    setIsZoomed={() => { }}
                    yAxisTitleVisible={false}
                    legendVisible={true}
                    multiChart={multiChart}
                />
            </React.Suspense>
        </div>;
    }, [availableKPIs, multiChart, dateSelection, userLimits, reloadAllSelectedTrendKpiData]);
    return <LoadingStatusWrapper
        useCustomAnchor
        transparent
        indicatorConfig={{ placement: 'sticky' }}
        loadingStatus={[loadingStatusForCharts, userLimitsLoadingStatus, trendLoadingStatus]}
    >
        <div className='multi-graph-view ' >
            {map(multiChartData, (chart) => {
                return renderChart(chart);
            })}
        </div>
    </LoadingStatusWrapper >;
};

TrendChartsComponent.propTypes = {
    actions: PropTypes.shape({
        loadMultiChartData: PropTypes.func
    }),
    model: PropTypes.shape({
        availableKPIs: PropTypes.array,
        multiChartPreselection: PropTypes.array,
        multiChartData: PropTypes.array,
        userLimits: PropTypes.array,
        userLimitsLoadingStatus: PropTypes.string,
        dateSelection: PropTypes.object,
        loadingStatusForCharts: PropTypes.string
    }),
    multiChart: PropTypes.string,
};

export default TrendChartsComponent;
